import React from "react";
import UploadPhoto from "site_media/images/default-profile-pic-feeds.png";
import AxiosConfig from "axiosConfig";

class ProfilePic extends React.Component {
  state = {
    profilePic: "",
  };

  componentDidMount() {
    AxiosConfig.get("/profile/details/profile-picture/")
      .then((res) => {
        this.setState({
          profilePic: res.data.profile_pic,
        });
      })
      .catch((err) => {});
  }

  render() {
    return this.state.profilePic === "" || this.state.profilePic === null ? (
      <div
        className="child-select__avatar"
        style={{ backgroundImage: `url(${UploadPhoto})` }}
      />
    ) : (
      <div
        className="child-select__avatar"
        style={{ backgroundImage: `url(${this.state.profilePic})` }}
      />
    );
  }
}

export default ProfilePic;
